module.exports = __webpack_public_path__ + "dist/img/pic.623b726d.png";